import { date as dateFactory } from '../../next-schema/generated/nodeTypes';
import { uuid } from '../../utils';

/**
 * @name date_node
 */

export const date = dateFactory({
  parseDOM: [{
    tag: 'span[data-node-type="date"]',
    getAttrs: dom => ({
      timestamp: dom.getAttribute('data-timestamp')
    })
  }],
  toDOM(node) {
    const attrs = {
      'data-node-type': 'date',
      'data-timestamp': node.attrs.timestamp
    };
    return ['span', attrs];
  }
});
export const dateWithLocalId = dateFactory({
  parseDOM: [{
    tag: 'span[data-node-type="date"]',
    getAttrs: dom => ({
      timestamp: dom.getAttribute('data-timestamp'),
      localId: uuid.generate()
    })
  }],
  toDOM(node) {
    var _node$attrs;
    const attrs = {
      'data-node-type': 'date',
      'data-timestamp': node.attrs.timestamp,
      'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
    };
    return ['span', attrs];
  }
});